package com.yendo.mx.repository

import com.yendo.mx.models.UsuarioYendo
import com.yendo.mx.models.InvitacionStaff
import com.yendo.mx.utils.SmsManager
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.firestore.firestore
import dev.gitlive.firebase.firestore.FieldValue
import dev.gitlive.firebase.firestore.where
import dev.gitlive.firebase.storage.storage
import dev.gitlive.firebase.functions.functions
import kotlinx.coroutines.*
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.catch
import com.yendo.mx.utils.getAhora
import com.yendo.mx.utils.toStorageData
import com.yendo.mx.utils.nativoSignInWithGoogle
import com.yendo.mx.utils.nativoSignInWithApple
import com.yendo.mx.utils.nativoVerifyPhoneNumber
import com.yendo.mx.utils.obtenerTokenFcmNativo
import com.yendo.mx.utils.obtenerEmailSocialPendiente
import com.yendo.mx.utils.obtenerNombreSocialPendiente
import com.yendo.mx.utils.obtenerApellidoSocialPendiente
import com.yendo.mx.utils.obtenerIdDispositivo
import com.yendo.mx.utils.obtenerFotoSocialPendiente
import com.yendo.mx.utils.obtenerMetadataDispositivo // 🚀 NUEVO
import com.yendo.mx.models.DispositivoVinculado // 🚀 NUEVO
import com.yendo.mx.utils.obtenerIdTokenSocialPendiente // 🚀 NUEVO
import dev.gitlive.firebase.auth.AuthResult
import dev.gitlive.firebase.auth.AuthCredential
import kotlinx.serialization.Serializable // 🚀 NUEVO

@Serializable
data class ColisionResponse(
    val colision: Boolean = false,
    val existe: Boolean = false, // 🚀 AÑADIDO
    val uidExistente: String? = null,
    val telefono: String? = null,
    val nombre: String? = null,
    val email: String? = null,
    val error: String? = null
)

object AuthRepository {
    private val auth = Firebase.auth
    private val db by lazy { Firebase.firestore }

    private val _usuarioActual = MutableStateFlow<UsuarioYendo?>(null)
    val usuarioActual: StateFlow<UsuarioYendo?> = _usuarioActual.asStateFlow()

    private val _isSocialLoginInProgress = MutableStateFlow(false)
    val isSocialLoginInProgress: StateFlow<Boolean> = _isSocialLoginInProgress.asStateFlow()

    private var socialCredentialPendiente: AuthCredential? = null 
    private var uidOrigenParaFusion: String? = null // 🚀 NUEVO
    private var socialPhotoPendiente: String? = null
    private var jobObservacion: Job? = null
    private val scope = CoroutineScope(Dispatchers.Main)

    init {
        scope.launch {
            auth.authStateChanged.collect { user ->
                println("YENDO_LOG AUTH: Estado -> ${user?.uid ?: "LOGOUT"}")
                if (user != null) observarUsuarioActual()
                else {
                    jobObservacion?.cancel()
                    _usuarioActual.value = null
                }
            }
        }
    }

    fun obtenerUid(): String? = auth.currentUser?.uid

    fun observarUsuarioActual() {
        val uid = auth.currentUser?.uid ?: return
        if (jobObservacion?.isActive == true && _usuarioActual.value?.uid == uid) return

        jobObservacion?.cancel()
        jobObservacion = scope.launch {
            try {
                db.collection("Usuarios").document(uid).snapshots
                    .catch { e -> 
                        println("YENDO_LOG ⚠️ [OBS] Error en flujo: ${e.message}")
                        if (e.message?.contains("PERMISSION_DENIED") == true) {
                            _usuarioActual.value = null
                        }
                    }
                    .collect { snapshot ->
                        val user = auth.currentUser
                    if (snapshot.exists) {
                        val roles = if (snapshot.contains("roles")) snapshot.get<Map<String, Boolean>>("roles") else emptyMap()
                        val phoneAuth = user?.phoneNumber?.replace("+52", "") ?: ""
                        val phoneDb = snapshot.get<String?>("telefono") ?: ""
                        
                        _usuarioActual.value = UsuarioYendo(
                            uid = snapshot.id,
                            nombre = snapshot.get<String?>("nombre") ?: "",
                            apellido = snapshot.get<String?>("apellido") ?: "",
                            telefono = phoneDb.ifBlank { phoneAuth },
                            email = snapshot.get<String?>("email") ?: user?.email ?: "",
                            emailVerificado = snapshot.get<Boolean?>("emailVerificado") ?: false,
                            fotoPerfil = snapshot.get<String?>("fotoPerfil") ?: "",
                            bloqueado = snapshot.get<Boolean?>("bloqueado") ?: false,
                            motivo_bloqueo = snapshot.get<String?>("motivo_bloqueo") ?: "",
                            metodos_pago_bloqueados = snapshot.get<String?>("metodos_pago_bloqueados") ?: "",
                            eliminacion_pendiente = snapshot.get<Boolean?>("eliminacion_pendiente") ?: false,
                            idNegocioVinculado = snapshot.get<String?>("idNegocioVinculado") ?: "",
                            metodosAcceso = snapshot.get<List<String>?>("metodosAcceso") ?: emptyList(),
                            dispositivosConfiables = snapshot.get<List<String>?>("dispositivosConfiables") ?: emptyList(),
                            infoDispositivos = snapshot.get<List<com.yendo.mx.models.DispositivoVinculado>?>("infoDispositivos") ?: emptyList(), // 🚀 NUEVO
                            emailsVinculados = snapshot.get<List<String>?>("emailsVinculados") ?: emptyList(),
                            invitacionStaff = if (snapshot.contains("invitacionStaff")) {
                                try { snapshot.get<com.yendo.mx.models.InvitacionStaff?>("invitacionStaff") } catch (e: Exception) { null }
                            } else null,
                            invitacionNegocio = if (snapshot.contains("invitacionNegocio")) {
                                try {
                                    val invData = snapshot.get<com.yendo.mx.models.InvitacionStaff?>("invitacionNegocio")
                                    invData?.let {
                                        mapOf(
                                            "idNegocio" to it.idNegocio,
                                            "nombreNegocio" to it.nombreNegocio,
                                            "rol" to it.rol,
                                            "estado" to it.estado
                                        )
                                    }
                                } catch (e: Exception) { null }
                            } else null, 
                            roles = roles
                        )
                    } else if (user != null) {
                        _usuarioActual.value = UsuarioYendo(uid = uid, email = user.email ?: "")
                    }
                }
            } catch (e: Exception) {
                println("YENDO_LOG ⚠️ [OBS] Error: ${e.message}")
            }
        }
    }

    suspend fun sincronizarMetodosAcceso() {
        val user = auth.currentUser ?: return
        try { 
            user.reload() 
            delay(1000) 
            user.reload()
        } catch(e: Exception) {} 
        
        val providers = obtenerListaProveedores()
        val deviceId = obtenerIdDispositivo()
        val meta = obtenerMetadataDispositivo()
        
        // 🚀 MEJORA: Buscamos el email de forma exhaustiva en todos los proveedores vinculados
        val socialEmail = (user.email ?: user.providerData.mapNotNull { it.email }.firstOrNull { it.isNotBlank() })?.lowercase()?.trim() ?: ""
        
        println("YENDO_LOG 🛡️ [SYNC] UID: ${user.uid}. Email Detectado: '$socialEmail'. Proveedores: $providers")
        
        val dispositivoActual = DispositivoVinculado(
            id = deviceId,
            nombre = meta["nombre"] ?: "Dispositivo Desconocido",
            modelo = meta["modelo"] ?: "",
            sistema = meta["sistema"] ?: "",
            ultimaConexion = getAhora()
        )
        
        try {
            val docRef = db.collection("Usuarios").document(user.uid)
            val existingDoc = try { docRef.get() } catch(e: Exception) { null }

            val updates = mutableMapOf<String, Any>(
                "uid" to user.uid,
                "metodosAcceso" to FieldValue.arrayUnion(*providers.toTypedArray()),
                "dispositivosConfiables" to FieldValue.arrayUnion(deviceId)
            )

            // 🚀 VINCULACIÓN AUTOMÁTICA DE FCM TOKEN EN SYNC DE LOGIN (GARANTIZADO)
            val currentFcmToken = savedFcmToken ?: obtenerTokenFcmNativo().takeIf { it.isNotBlank() }
            if (!currentFcmToken.isNullOrBlank()) {
                savedFcmToken = currentFcmToken
                updates["fcmTokens"] = FieldValue.arrayUnion(currentFcmToken)
                println("YENDO_LOG 📲 [SYNC] Registrando fcmTokens en login: $currentFcmToken")
            }

            // ACTUALIZAR LISTA DE DISPOSITIVOS DETALLADA
            val listaExistente = if (existingDoc?.contains("infoDispositivos") == true) {
                existingDoc.get<List<DispositivoVinculado>>("infoDispositivos")
            } else emptyList()

            val nuevaLista = (listaExistente.filter { it.id != deviceId } + dispositivoActual)
                .sortedByDescending { it.ultimaConexion }
            
            updates["infoDispositivos"] = nuevaLista

            val phoneAuth = user.phoneNumber ?: ""
            if (phoneAuth.isNotBlank()) updates["telefono"] = phoneAuth

            // 🛡️ REGLA DE PROTECCIÓN DE EMAIL Y CORREO
            if (socialEmail.isNotBlank()) {
                updates["emailsVinculados"] = FieldValue.arrayUnion(socialEmail)
                
                // Si el documento ya existe, verificamos si ya tiene un email principal
                val emailActual = if (existingDoc?.contains("email") == true) existingDoc.get<String>("email") else ""
                if (emailActual.isBlank()) {
                    updates["email"] = socialEmail
                    println("YENDO_LOG 📧 [SYNC] Estableciendo email principal: $socialEmail")
                }
            }

            db.collection("Usuarios").document(user.uid).set(updates, merge = true)
            println("YENDO_LOG ✅ [SYNC] Firestore sincronizado correctamente.")
        } catch (e: Exception) { println("YENDO_LOG ❌ [SYNC] Error crítico: ${e.message}") }
    }

    fun obtenerNombreSocial(): String? = obtenerNombreSocialPendiente()
    fun obtenerApellidoSocial(): String? = obtenerApellidoSocialPendiente()
    fun obtenerEmailSocial(): String? = obtenerEmailSocialPendiente()
    fun obtenerFotoSocial(): String? = obtenerFotoSocialPendiente()
    fun estaLogueado(): Boolean = auth.currentUser != null

    suspend fun buscarPropietarioTelefono(telefono: String): String? {
        val currentUid = auth.currentUser?.uid
        return try {
            val telLimpio = telefono.trim()
            val snap = db.collection("Usuarios").where { "telefono" equalTo telLimpio }.limit(1).get()
            val doc = snap.documents.firstOrNull { it.id != currentUid }
            if (doc != null) {
                doc.get<String?>("nombre")?.ifBlank { "Usuario" } ?: "Usuario"
            } else null
        } catch (e: Exception) { null }
    }

    suspend fun enviarCorreoVerificacion(emailAlternativo: String? = null): String {
        println("YENDO_LOG 📧 [VERIFY] Iniciando proceso maestro...")
        return try {
            val user = auth.currentUser ?: return "Usuario no autenticado"
            try { user.reload() } catch(e: Exception) {}
            
            val emailDestino = (emailAlternativo ?: _usuarioActual.value?.email ?: "").lowercase().trim()
            if (emailDestino.isBlank()) return "No hay correo asociado."

            val emailEnAuth = user.email?.lowercase()?.trim()
            println("YENDO_LOG 📧 [VERIFY] AuthEmail: '$emailEnAuth' | Destino: '$emailDestino'")

            if (emailEnAuth == emailDestino) {
                user.sendEmailVerification()
                println("YENDO_LOG ✅ [VERIFY] Reenvío estándar exitoso.")
                return "OK"
            }

            println("YENDO_LOG 📧 [VERIFY] Intentando vincular nuevo email...")
            try {
                user.verifyBeforeUpdateEmail(emailDestino)
                println("YENDO_LOG ✅ [VERIFY] verifyBeforeUpdateEmail lanzado con éxito.")
                "OK"
            } catch (e: Exception) {
                val msg = e.message ?: ""
                if (msg.contains("recent-login")) return "Por seguridad, vuelve a iniciar sesión para validar tu correo."
                if (msg.contains("already-in-use") || msg.contains("collision")) return "Este correo ya le pertenece a otra cuenta de Google/Apple."
                user.updateEmail(emailDestino)
                user.sendEmailVerification()
                "OK"
            }
        } catch (e: Exception) {
            val finalErr = e.message ?: ""
            println("YENDO_LOG ❌ [VERIFY] ERROR FINAL: $finalErr")
            "No se pudo enviar el correo: $finalErr"
        }
    }

    fun enviarSmsValidacion(telefono: String, contexto: Any?, onCodigoEnviado: (String) -> Unit, onError: (String) -> Unit) {
        scope.launch {
            try {
                val verId = nativoVerifyPhoneNumber(telefono, contexto)
                if (verId != null) onCodigoEnviado(verId) else onError("timeout")
            } catch (e: Exception) { onError(e.message ?: "Error SMS") }
        }
    }

    fun confirmarSmsYFinalizar(verificationId: String, codigo: String, esFusion: Boolean = false, onSuccess: () -> Unit, onError: (String) -> Unit) {
        _isSocialLoginInProgress.value = true
        scope.launch {
            try {
                val phoneCredential = dev.gitlive.firebase.auth.PhoneAuthProvider(auth).credential(verificationId, codigo)
                val socialCred = socialCredentialPendiente
                val currentUser = auth.currentUser 
                
                var uidOrigenParaConsolidar: String? = uidOrigenParaFusion

                if (esFusion && currentUser != null && !currentUser.isAnonymous) {
                    // Caso A: Fusión con sesión social ya activa (Google o fallback)
                    println("YENDO_LOG 🧹 [SMS] Modo Fusión (Activo): Preparando migración...")
                    uidOrigenParaConsolidar = currentUser.uid
                    auth.signOut()
                    auth.signInWithCredential(phoneCredential)
                } else if (esFusion && socialCred != null) {
                    // Caso B: Fusión detectada SILENCIOSAMENTE (Token fresco)
                    println("YENDO_LOG 🛡️ [SMS] Modo Fusión (Silencioso): Iniciando en cuenta maestra...")
                    auth.signInWithCredential(phoneCredential)
                } else if (currentUser != null && !currentUser.isAnonymous) {
                    // Caso C: Vínculo simple (Usuario logueado añade teléfono nuevo)
                    println("YENDO_LOG 🔗 [SMS] Modo Vínculo: Añadiendo teléfono a cuenta social...")
                    try { currentUser.linkWithCredential(phoneCredential) } catch(e: Exception) { auth.signInWithCredential(phoneCredential) }
                } else {
                    // Caso D: Login normal o Registro nuevo
                    println("YENDO_LOG 📱 [SMS] Modo Login: Entrada directa...")
                    auth.signInWithCredential(phoneCredential)
                }

                val masterUser = auth.currentUser
                if (masterUser != null) {
                    // 🚀 1. CONSOLIDACIÓN: Si venimos de otra cuenta, movemos los datos
                    if (uidOrigenParaConsolidar != null && uidOrigenParaConsolidar != masterUser.uid) {
                        try {
                            println("YENDO_LOG 📦 [SMS] Llamando a consolidarCuentas (Origen: $uidOrigenParaConsolidar)...")
                            val callable = Firebase.functions.httpsCallable("consolidarCuentas")
                            callable.invoke(mapOf("uidOrigen" to uidOrigenParaConsolidar))
                            println("YENDO_LOG ✅ [SMS] Consolidación completada.")
                            delay(800)
                        } catch (e: Exception) {
                            println("YENDO_LOG ⚠️ [SMS] Fallo en consolidación: ${e.message}")
                        }
                    }

                    // 🚀 2. ACCOUNT LINKING: Unimos la identidad social a la cuenta maestra
                    if (socialCred != null) {
                        try { 
                            println("YENDO_LOG 🔗 [SMS] Realizando Account Linking...")
                            masterUser.linkWithCredential(socialCred) 
                            println("YENDO_LOG ✅ [SMS] ¡FUSIÓN DE IDENTIFICADORES EXITOSA!")
                        } catch(e2: Exception) {
                            val msg = e2.message ?: ""
                            if (msg.contains("already-linked") || msg.contains("already-in-use")) {
                                println("YENDO_LOG ℹ️ El identificador ya estaba vinculado.")
                            } else {
                                println("YENDO_LOG ❌ Error en vínculo: $msg")
                            }
                        }
                    }
                }

                socialCredentialPendiente = null
                uidOrigenParaFusion = null
                sincronizarMetodosAcceso()
                _isSocialLoginInProgress.value = false
                observarUsuarioActual()
                onSuccess()
            } catch (e: Exception) { 
                _isSocialLoginInProgress.value = false
                println("YENDO_LOG ❌ [SMS] Error en flujo final: ${e.message}")
                onError("Código SMS incorrecto o fallo de red") 
            }
        }
    }

    fun confirmarSmsYActualizar(verificationId: String, codigoIngresado: String, nombre: String, apellido: String, nuevoTelefono: String, correo: String, onSuccess: () -> Unit, onError: (String) -> Unit) {
        _isSocialLoginInProgress.value = true
        scope.launch {
            try {
                val credential = dev.gitlive.firebase.auth.PhoneAuthProvider(auth).credential(verificationId, codigoIngresado)
                val userAuth = auth.currentUser
                
                if (userAuth != null) {
                    try {
                        userAuth.linkWithCredential(credential)
                    } catch (e: Exception) {
                        try {
                            userAuth.updatePhoneNumber(credential)
                        } catch (e2: Exception) {}
                    }

                    val updates = mutableMapOf<String, Any>(
                        "telefono" to nuevoTelefono,
                        "nombre" to nombre.trim(),
                        "apellido" to apellido.trim(),
                        "email" to correo.lowercase().trim()
                    )
                    db.collection("Usuarios").document(userAuth.uid).set(updates, merge = true)
                    sincronizarMetodosAcceso()
                    onSuccess()
                } else { 
                    auth.signInWithCredential(credential)
                    onSuccess() 
                }
                _isSocialLoginInProgress.value = false
                observarUsuarioActual()
            } catch (e: Exception) { 
                _isSocialLoginInProgress.value = false
                onError(e.message ?: "Error") 
            }
        }
    }

    suspend fun actualizarPerfilBase(nombre: String, apellido: String, email: String = "", telefono: String = ""): String {
        val user = auth.currentUser ?: return "Error Auth"
        val emailLimpio = email.lowercase().trim()
        
        return try {
            if (emailLimpio.isNotBlank()) {
                val existing = coroutineScope {
                    val d1 = async { db.collection("Usuarios").where { "email" equalTo emailLimpio }.limit(1).get().documents }
                    val d3 = async { db.collection("Usuarios").where { "emailsVinculados" contains emailLimpio }.limit(1).get().documents }
                    d1.await() + d3.await()
                }
                
                val conflictive = existing.firstOrNull { it.id != user.uid }
                if (conflictive != null) {
                    val phone = conflictive.get<String?>("telefono") ?: ""
                    return "EMAIL_ALREADY_IN_USE|$phone"
                }
            }

            val docRef = db.collection("Usuarios").document(user.uid)
            val existingDoc = try { docRef.get() } catch(e: Exception) { null }
            val updates = mutableMapOf<String, Any>()
            
            if (nombre.isNotBlank()) updates["nombre"] = nombre.trim()
            if (apellido.isNotBlank()) updates["apellido"] = apellido.trim()

            val emailDb = if (existingDoc?.contains("email") == true) existingDoc.get<String>("email") else ""
            if (emailDb.isBlank() && emailLimpio.isNotBlank()) {
                updates["email"] = emailLimpio
                try { user.verifyBeforeUpdateEmail(emailLimpio) } catch(e: Exception) {}
            }
            if (telefono.isNotBlank()) updates["telefono"] = telefono.trim()

            docRef.set(updates, merge = true)
            sincronizarMetodosAcceso()
            "OK"
        } catch (e: Exception) { e.message ?: "Error" }
    }

    suspend fun iniciarSesionConGoogle(): String = iniciarSesionSocial("Google", null)
    suspend fun iniciarSesionConApple(): String = iniciarSesionSocial("Apple", null)

    suspend fun loginConGoogle(idToken: String, nombre: String, apellido: String, email: String, fotoUrl: String? = null): String {
        val credential = dev.gitlive.firebase.auth.GoogleAuthProvider.credential(idToken, null)
        return iniciarSesionSocial("Google", credential, email, fotoUrl)
    }

    private suspend fun iniciarSesionSocial(provider: String, credencialPrevia: AuthCredential?, emailForzado: String? = null, fotoForzada: String? = null): String {
        println("YENDO_LOG 🔵 [$provider] Iniciando reconocimiento...")
        _isSocialLoginInProgress.value = true
        return try {
            val credential = credencialPrevia ?: (if (provider == "Google") nativoSignInWithGoogle() else nativoSignInWithApple())
            if (credential == null) return "CANCELADO".also { _isSocialLoginInProgress.value = false }
            
            // 🚀 VERIFICACIÓN DE COLISIÓN "SILENCIOSA" (Blindaje Apple Single-Use Token)
            val idTokenParaValidar = obtenerIdTokenSocialPendiente()
            if (idTokenParaValidar != null) {
                println("YENDO_LOG 🔍 [$provider] Verificando existencia en el servidor...")
                try {
                    val callable = Firebase.functions.httpsCallable("verificarColisionSocial")
                    val result = callable.invoke(mapOf("idToken" to idTokenParaValidar, "provider" to provider.lowercase()))
                    
                    // 🚀 OBTENCIÓN SEGURA SIN CLASES EXTRA (Evita error de Serializer en iOS)
                    val data = result.data<Map<String, Any?>>()
                    val existe = data["existe"] as? Boolean ?: false
                    val colision = data["colision"] as? Boolean ?: false
                    
                    if (existe && colision) {
                        // Caso A: Existe cuenta maestra (con teléfono). Forzamos vínculo.
                        val phone = data["telefono"] as? String ?: ""
                        val nombre = data["nombre"] as? String ?: ""
                        val emailS = data["email"] as? String ?: ""
                        
                        println("YENDO_LOG 🛡️ [$provider] COLISIÓN MAESTRA DETECTADA (Servidor).")
                        
                        uidOrigenParaFusion = data["uidExistente"] as? String
                        socialPhotoPendiente = fotoForzada ?: obtenerFotoSocial()
                        socialCredentialPendiente = credential
                        _isSocialLoginInProgress.value = false
                        return "COLLISION_VINCULAR|$phone|$nombre|$emailS"
                    } else if (!existe) {
                        // Caso B: Usuario totalmente nuevo. NO logueamos aún para no quemar el token.
                        println("YENDO_LOG 🆕 [$provider] Nuevo usuario. Postergando login.")
                        socialPhotoPendiente = fotoForzada ?: obtenerFotoSocial()
                        socialCredentialPendiente = credential
                        _isSocialLoginInProgress.value = false
                        return "OK" 
                    }
                    // Caso C: Usuario social existente (sin teléfono). Procedemos al login normal.
                    println("YENDO_LOG 👤 [$provider] Usuario recurrente detectado.")
                } catch (e: Exception) {
                    println("YENDO_LOG ⚠️ Error en validación silenciosa: ${e.message}")
                }
            }

            // 🚀 LOGIN: Si llegamos aquí es un usuario social recurrente o falló el server
            println("YENDO_LOG 🔐 [$provider] Autenticando en Firebase Auth...")
            val result = auth.signInWithCredential(credential)
            val uid = result.user?.uid ?: return "Error Auth".also { _isSocialLoginInProgress.value = false }
            
            val email = (emailForzado ?: result.user?.email ?: obtenerEmailSocial())?.lowercase()?.trim() ?: ""
            println("YENDO_LOG 👤 [$provider] Identidad: $uid | Email: $email")

            val docRef = db.collection("Usuarios").document(uid)
            val snap = try { docRef.get() } catch (e: Exception) { null }

            if (snap != null && snap.exists) {
                val phone = snap.get<String?>("telefono") ?: ""
                if (phone.isNotBlank()) {
                    socialPhotoPendiente = fotoForzada ?: email.ifBlank { null }?.let { obtenerFotoSocial() }
                    sincronizarMetodosAcceso()
                    _isSocialLoginInProgress.value = false
                    return "OK"
                }
            } else {
                // Fallback manual de colisión (por si el servidor falló)
                if (email.isNotBlank()) {
                    val existing = coroutineScope {
                        val d1 = async { db.collection("Usuarios").where { "email" equalTo email }.limit(1).get().documents }
                        val d2 = async { db.collection("Usuarios").where { "correo" equalTo email }.limit(1).get().documents }
                        val d3 = async { db.collection("Usuarios").where { "emailsVinculados" contains email }.limit(1).get().documents }
                        d1.await() + d2.await() + d3.await()
                    }
                    
                    val conflictive = existing.firstOrNull { it.id != uid }
                    if (conflictive != null) {
                        val phone = conflictive.get<String?>("telefono") ?: ""
                        val nombre = conflictive.get<String?>("nombre") ?: ""
                        println("YENDO_LOG 🛡️ [$provider] COLISIÓN MANUAL: $email")
                        socialCredentialPendiente = credential
                        _isSocialLoginInProgress.value = false
                        return "COLLISION_VINCULAR|$phone|$nombre|$email"
                    }
                }
            }

            socialPhotoPendiente = fotoForzada ?: email.ifBlank { null }?.let { obtenerFotoSocial() }
            socialCredentialPendiente = credential
            sincronizarMetodosAcceso()
            _isSocialLoginInProgress.value = false
            "OK"
        } catch (e: Exception) {
            println("YENDO_LOG ❌ [$provider] ERROR CRÍTICO: ${e.message}")
            _isSocialLoginInProgress.value = false
            e.message ?: "Error"
        }
    }

    suspend fun loginAnonimo(): Boolean = try { auth.signInAnonymously(); true } catch (e: Exception) { false }

    private var savedFcmToken: String? = null

    suspend fun actualizarTokenPush(token: String) {
        val uid = auth.currentUser?.uid ?: return
        if (token.isBlank()) return
        
        savedFcmToken = token // 🚀 GUARDAR EN MEMORIA
        
        try { 
            db.collection("Usuarios").document(uid).set(
                mapOf("fcmTokens" to FieldValue.arrayUnion(token)),
                merge = true
            ) 
            println("YENDO_LOG: 📲 Token Push Usuario registrado en Firestore y guardado en memoria: $token")
            reportarTelemetria(uid)
        } catch (e: Exception) {
            println("YENDO_LOG ERROR: Fallo al registrar token push usuario -> ${e.message}")
        }
    }

    /**
     * 🚀 TELEMETRÍA PRO: Informa al sistema sobre la versión y hardware del usuario.
     * Esto alimenta los gráficos de adopción en Yendo OS.
     */
    suspend fun reportarTelemetria(uid: String) {
        try {
            val metadata = com.yendo.mx.utils.obtenerMetadataDispositivo()
            val payload = mapOf(
                "dispositivo" to mapOf(
                    "version_code" to (metadata["version_code"]?.toIntOrNull() ?: 0),
                    "version_name" to (metadata["version_name"] ?: "1.0.0"),
                    "plataforma" to (metadata["plataforma"] ?: "Unknown"),
                    "modelo" to (metadata["modelo"] ?: "Unknown"),
                    "sistema" to (metadata["sistema"] ?: "Unknown"),
                    "ultima_conexion" to getAhora()
                )
            )
            db.collection("Usuarios").document(uid).set(payload, merge = true)
            println("YENDO_LOG: 📡 Telemetría enviada con éxito.")
        } catch (e: Exception) {
            println("YENDO_LOG: ⚠️ Error al enviar telemetría: ${e.message}")
        }
    }

    fun prepararCredencialSocial(idToken: String, provider: String, rawNonce: String? = null) {
        socialCredentialPendiente = if (provider == "Google") {
            dev.gitlive.firebase.auth.GoogleAuthProvider.credential(idToken, null)
        } else {
            dev.gitlive.firebase.auth.OAuthProvider.credential("apple.com", accessToken = null, idToken = idToken, rawNonce = rawNonce)
        }
    }

    fun detenerBloqueoNavegacion() { _isSocialLoginInProgress.value = false }

    fun cancelarLoginSocial() {
        _isSocialLoginInProgress.value = false
        socialCredentialPendiente = null
        socialPhotoPendiente = null
        scope.launch { try { auth.signOut() } catch(e: Exception) {} }
    }

    suspend fun recargarUsuario() {
        try {
            val user = auth.currentUser ?: return
            user.reload()
            if (user.isEmailVerified) db.collection("Usuarios").document(user.uid).update("emailVerificado" to true)
            observarUsuarioActual()
        } catch (e: Exception) {}
    }

    suspend fun cerrarSesion() = withContext(NonCancellable) {
        val uid = auth.currentUser?.uid
        val token = savedFcmToken ?: obtenerTokenFcmNativo().takeIf { it.isNotBlank() }
        println("YENDO_LOG: 🚪 [USUARIO] Iniciando Cierre de Sesión Total NO-CANCELABLE para $uid. Token FCM: ${token ?: "NULO"}")
        
        try {
            jobObservacion?.cancel()
            jobObservacion = null
        } catch (e: Throwable) {}

        if (uid != null && !token.isNullOrBlank()) {
            try {
                db.collection("Usuarios").document(uid).update(
                    "fcmTokens" to FieldValue.arrayRemove(token)
                )
                println("YENDO_LOG: 🧹 [USUARIO] Token $token removido con éxito de Firestore para $uid")
            } catch (e: Exception) {
                println("YENDO_LOG ERROR: Fallo al remover FCM token de Firestore -> ${e.message}")
            }
        }
        savedFcmToken = null
        
        try {
            auth.signOut()
            println("YENDO_LOG: ✅ [USUARIO] Firebase Auth signOut completado.")
        } catch (e: Throwable) {}

        try {
            com.yendo.mx.utils.nativoLogout()
            println("YENDO_LOG: ✅ [USUARIO] Logout nativo completado.")
        } catch (e: Throwable) {}

        _usuarioActual.value = null
        socialCredentialPendiente = null 
        socialPhotoPendiente = null
        println("YENDO_LOG: ✅ [USUARIO] Estado de Auth Usuario reseteado limpiamente.")
    }

    suspend fun solicitarEliminacionCuenta(motivo: String): String {
        val user = auth.currentUser ?: return "Error"
        return try {
            db.collection("Usuarios").document(user.uid).update("eliminacion_pendiente" to true, "motivo_eliminacion" to motivo, "fecha_solicitud_eliminacion" to getAhora())
            cerrarSesion()
            "OK"
        } catch (e: Exception) { "Error" }
    }

    suspend fun restaurarCuenta(): String {
        val user = auth.currentUser ?: return "Error"
        return try {
            db.collection("Usuarios").document(user.uid).update("eliminacion_pendiente" to false, "motivo_eliminacion" to FieldValue.delete, "fecha_solicitud_eliminacion" to FieldValue.delete)
            "OK"
        } catch (e: Exception) { "Error" }
    }

    suspend fun subirFotoPerfilKMP(datosImagen: ByteArray): String {
        val user = auth.currentUser ?: return "Error"
        return try {
            val storageRef = Firebase.storage.reference.child("perfiles/${user.uid}.jpg")
            storageRef.putData(datosImagen.toStorageData())
            val downloadUrl = storageRef.getDownloadUrl()
            db.collection("Usuarios").document(user.uid).update("fotoPerfil" to downloadUrl)
            "OK"
        } catch (e: Exception) { "Error" }
    }

    suspend fun cambiarCorreo(nuevoCorreo: String, passwordActual: String): String {
        val user = auth.currentUser ?: return "Error"
        val emailActual = user.email ?: return "Error"
        return try {
            val credential = dev.gitlive.firebase.auth.EmailAuthProvider.credential(emailActual, passwordActual)
            user.reauthenticate(credential)
            user.verifyBeforeUpdateEmail(nuevoCorreo)
            "REVISA_TU_CORREO"
        } catch (e: Exception) { "Fallo: ${e.message}" }
    }

    suspend fun cambiarPassword(passwordActual: String, nuevaPassword: String): String {
        val user = auth.currentUser ?: return "Error"
        val email = user.email ?: return "Error"
        return try {
            auth.signInWithEmailAndPassword(email, passwordActual)
            user.updatePassword(nuevaPassword)
            "OK"
        } catch (e: Exception) { "Error: ${e.message}" }
    }

    suspend fun enviarCorreoRecuperacion(email: String): String = try { auth.sendPasswordResetEmail(email); "OK" } catch (e: Exception) { "Error" }

    fun obtenerProveedorAuth(): String {
        val user = auth.currentUser ?: return "Telefono"
        val proveedores = user.providerData.map { it.providerId.lowercase() }
        return when {
            proveedores.any { it.contains("google") } -> "Google"
            proveedores.any { it.contains("apple") } -> "Apple"
            proveedores.any { it.contains("password") } -> "Correo"
            else -> "Telefono"
        }
    }

    fun obtenerListaProveedores(): List<String> {
        val user = auth.currentUser ?: return emptyList()
        val providers = user.providerData.map { it.providerId.lowercase() }
        val list = mutableListOf<String>()
        providers.forEach { id ->
            when {
                id.contains("google") -> list.add("Google")
                id.contains("apple") -> list.add("Apple")
                id.contains("phone") -> list.add("Telefono")
                id.contains("password") -> list.add("Correo")
            }
        }
        return list.distinct()
    }
    
    suspend fun aceptarInvitacionDeTrabajo(invitacion: InvitacionStaff): String {
        return try {
            val callable = Firebase.functions.httpsCallable("responderInvitacionStaff")
            callable.invoke(mapOf("respuesta" to "ACEPTAR"))
            "OK"
        } catch (e: Exception) { e.message ?: "Error" }
    }

    suspend fun rechazarInvitacionDeTrabajo(): String {
        return try {
            val callable = Firebase.functions.httpsCallable("responderInvitacionStaff")
            callable.invoke(mapOf("respuesta" to "RECHAZAR"))
            "OK" 
        } catch (e: Exception) { e.message ?: "Error" }
    }

    // 🚀 NUEVOS MÉTODOS PARA INVITACIÓN DE EQUIPO UNIFICADA
    suspend fun aceptarInvitacionEquipo(): String {
        return try {
            val callable = Firebase.functions.httpsCallable("responderInvitacionStaff")
            callable.invoke(mapOf("respuesta" to "ACEPTAR"))
            "OK"
        } catch (e: Exception) { e.message ?: "Error" }
    }

    suspend fun rechazarInvitacionEquipo(): String {
        return try {
            val callable = Firebase.functions.httpsCallable("responderInvitacionStaff")
            callable.invoke(mapOf("respuesta" to "RECHAZAR"))
            "OK"
        } catch (e: Exception) { e.message ?: "Error" }
    }
}
